import util from "../libs/util";
let loadDom = null;
/**
 * 判断是否存在
 * @param {Object} value
 */
function isDefine(value) {
    if (value == null || value == "" || value == "undefined" || value == undefined || value == "null" || value == "(null)" || value == 'NULL' || typeof (value) == 'undefined') {
        return false;
    }
    else {
        value = value + "";
        value = value.replace(/\s/g, "");
        if (value == "") {
            return false;
        }
        return true;
    }
}


/**
 * 判断权限
 * @param paths
 * @param value
 */
const checkPermissions = (paths,value) => {
  if(paths.is_system == null) return  false;
  if(paths.is_system == 1) return true;
  for(var i in paths.data) {
    if(paths.data[i].trim() == value.trim()) {
      return  true;
    }
  }
  return  false;
}


/**
 * 时间戳格式化函数
 * @param  {string} format    格式
 * @param  {int}    timestamp 要格式化的时间 默认为当前时间
 * @return {string}           格式化的时间字符串
 */
function date(format, timestamp) {
    var a, jsdate = ((timestamp) ? new Date(timestamp * 1000) : new Date());
    var pad = function (n, c) {
        n = n + "";
        if (n.length < c) {
            var i = c - n.length;
            var v = '';
            for (var j = 0; j < i; j++) {
                v += '0';
            }
            return v + n;
        } else {
            return n;
        }
    };
    var txt_weekdays = ["周日", "周一", "周二", "周三", "周四", "周五", "周六"];
    var txt_ordin = { "1": "st", "2": "nd", "3": "rd", "21": "st", "22": "nd", "23": "rd", "31": "st" };
    var txt_months = ["", "January", "February", "March", "April", "May", "June", "July", "August", "September", "October", "November", "December"];

    var f = {
        // Day
        d: function () { return pad(f.j(), 2) },
        D: function () { return f.l().substr(0, 3) },
        j: function () { return jsdate.getDate() },
        l: function () { return txt_weekdays[f.w()] },
        N: function () { return f.w() + 1 },
        S: function () { return txt_ordin[f.j()] ? txt_ordin[f.j()] : 'th' },
        w: function () { return jsdate.getDay() }
        ,
        // Week
        W: function () {
            var a = f.z(), b = 364 + f.L() - a;
            var nd2, nd = (new Date(jsdate.getFullYear() + "/1/1").getDay() || 7) - 1;
            if (b <= 2 && ((jsdate.getDay() || 7) - 1) <= 2 - b) {
                return 1;
            } else {
                if (a <= 2 && nd >= 4 && a >= (6 - nd)) {
                    nd2 = new Date(jsdate.getFullYear() - 1 + "/12/31");
                    return date("W", Math.round(nd2.getTime() / 1000));
                } else {
                    return (1 + (nd <= 3 ? ((a + nd) / 7) : (a - (7 - nd)) / 7) >> 0);
                }
            }
        },

        // Month
        F: function () { return txt_months[f.n()] },
        m: function () { return pad(f.n(), 2) },
        M: function () { return f.F().substr(0, 3) },
        n: function () { return jsdate.getMonth() + 1 },
        t: function () {
            var n;
            if ((n = jsdate.getMonth() + 1) == 2) {
                return 28 + f.L();
            } else {
                if (n & 1 && n < 8 || !(n & 1) && n > 7) {
                    return 31;
                } else {
                    return 30;
                }
            }
        },
        //o not supported yet
        Y: function () { return jsdate.getFullYear() },
        y: function () { return (jsdate.getFullYear() + "") },

        // Time
        a: function () { return jsdate.getHours() > 11 ? "pm" : "am" },
        A: function () { return f.a().toUpperCase() },
        B: function () {
            // peter paul koch:
            var off = (jsdate.getTimezoneOffset() + 60) * 60;
            var theSeconds = (jsdate.getHours() * 3600) + (jsdate.getMinutes() * 60) + jsdate.getSeconds() + off;
            var beat = Math.floor(theSeconds / 86.4);
            if (beat > 1000) beat -= 1000;
            if (beat < 0) beat += 1000;
            if ((String(beat)).length == 1) beat = "00" + beat;
            if ((String(beat)).length == 2) beat = "0" + beat;
            return beat;
        },
        g: function () { return jsdate.getHours() % 12 || 12 },
        G: function () { return jsdate.getHours() },
        h: function () { return pad(f.g(), 2) },
        H: function () { return pad(jsdate.getHours(), 2) },
        i: function () { return pad(jsdate.getMinutes(), 2) },
        s: function () { return pad(jsdate.getSeconds(), 2) },
        //u not supported yet

        // Timezone
        //e not supported yet
        //I not supported yet
        O: function () {
            var t = pad(Math.abs(jsdate.getTimezoneOffset() / 60 * 100), 4);
            if (jsdate.getTimezoneOffset() > 0) t = "-" + t; else t = "+" + t;
            return t;
        },
        P: function () { var O = f.O(); return (O.substr(0, 3) + ":" + O.substr(3, 2)) },
        //T not supported yet
        //Z not supported yet

        // Full Date/Time
        c: function () { return f.Y() + "-" + f.m() + "-" + f.d() + "T" + f.h() + ":" + f.i() + ":" + f.s() + f.P() },
        //r not supported yet
        U: function () { return Math.round(jsdate.getTime() / 1000) }
    };
    return format.replace(/[\\]?([a-zA-Z])/g, function (t, s) {
        var ret = '';
        if (t != s) {
            ret = s;
        } else if (f[s]) {
            ret = f[s]();
        } else {
            ret = s;
        }
        return ret;
    });
}

/**
 * strtotime()函数
 * strtotime('2012-07-27 12:43:43') OR strtotime('2012-07-27')
 * @return 时间戳
 */
function strtotime(str = '') {
    if(str == '') {
        var _temp = new Date();
        return parseInt(_temp.getTime() / 1000);
    }
    var _arr = str.split(' ');
    var _day = _arr[0].split('-');
    _arr[1] = (_arr[1] == null) ? '0:0:0' : _arr[1];
    var _time = _arr[1].split(':');
    for (var i = _day.length - 1; i >= 0; i--) {
        _day[i] = isNaN(parseInt(_day[i])) ? 0 : parseInt(_day[i]);
    };
    for (var i = _time.length - 1; i >= 0; i--) {
        _time[i] = isNaN(parseInt(_time[i])) ? 0 : parseInt(_time[i]);
    };
    var _temp = new Date(_day[0], _day[1] - 1, _day[2], _time[0], _time[1], _time[2]);
    return parseInt(_temp.getTime() / 1000);
}

/**
 * 小数保留默认2位
 */
function returnFloat(value) {
    var value = Math.round(parseFloat(value) * 100) / 100;
    var xsd = value.toString().split(".");
    if (xsd.length == 1) {
        value = value.toString() + ".00";
        return value;
    }
    if (xsd.length > 1) {
        if (xsd[1].length < 2) {
            value = value.toString() + "0";
        }
        return value;
    }
}

/**
 * 加载laoding
 * @param text
 */
const loading = (page,text) => {
    loadDom =  page.$loading({
        lock: true,
        text: text,
        spinner: 'el-icon-loading',
        background: 'rgba(0, 0, 0, 0.7)'
    });

    return loadDom;
};
/**
 * 关闭加载层..
 */
const loadingClose = ()=>{
    if(loadDom != null) {
        loadDom.close();
        loadDom = null;
    }
}

function timest() {
    var tmp = Date.parse( new Date() ).toString();
    tmp = tmp.substr(0,10);
    return tmp;
}

/**
 * 域名信息
 * @returns {{router: *, prefix: *, query: *, domain: *}}
 */
function urlParam() {
  var myURL = new URL(window.document.location.href);
  //get参数
  var url = location.search;
  var theRequest = {};
  if (url.indexOf("?") != -1) {
    var str = url.substr(1);
    var strs = str.split("&");
    for(var i = 0; i < strs.length; i ++) {
      theRequest[strs[i].split("=")[0]] = unescape(strs[i].split("=")[1]);
    }
  }
  myURL.query = theRequest;
  return myURL;
}


/**
 * 初始化数据
 * @param data
 * @param def
 * @returns {*}
 */
function resetFields(data,def = {}) {
  var newAr = {};
  for(var i in data) {
    if(def[i] != null) {
      newAr[i] = def[i];
    } else {
      if(typeof(data[i]) =="number") {
        newAr[i] = 0;
      } else {
        newAr[i] = '';
      }
    }
  }
  return newAr;
}

/**
 * 获取图片位置
 * @param img
 * @param index
 */
function imgAr(img,index = -1) {
    if(img == '' || img == null) return null;
    var imgR = img.split(',');
    if(index == -1) return  imgR;
    if(imgR.length > index) return imgR[index];
    return  null;
}

/**
 * 判断手机号码是否准确
 */
const isPoneAvailable = (tel) => {
  var myreg=/^[1][3,4,5,6,7,8,9][0-9]{9}$/;
  if (!myreg.test(tel)) {
    return false;
  } else {
    return true;
  }
};

/**
 * 倒计时【验证码】
 * @time 倒计时 秒
 * @结束
 */
function CountDowm(time, fe = null) {
  var id = setInterval(() => {
    time--;
    if (fe != null) fe(time, 0);
    if (time <= 0) {
      clearInterval(id);
      fe(0, 1);
    }
  }, 1000);
}

function getDateTime(date) {
  let dateTime
  let yy =date.getFullYear()
  let mm = date.getMonth() + 1
  let dd = date.getDate()
  let hh = date.getHours()
  let mf = date.getMinutes() < 10 ? '0' + date.getMinutes()
    :
    date.getMinutes()
  let ss = date.getSeconds() < 10 ? '0' + date.getSeconds()
    :
    date.getSeconds()
  dateTime = yy + '-' + mm + '-' + dd + ' ' + hh + ':' + mf + ':' + ss
  return dateTime
}


function RichText(html) {
  if(!isDefine(html)) return '';
  html = html.replace(/\n/g,'<br>');
  return  html;
}




/**
 * 自动计算高度 | 宽度
 * @param width 原始
 * @param height 原始
 * @param mWidth 现在 0不参与计算
 * @param mHeight 现在
 */
function getAotuWidth(width,height,mWidth,mHeight = 0) {
  if(mWidth > 0 && mHeight == 0) {
    return (height / width) * mWidth;
  }

  if(mWidth == 0 && mHeight > 0) {
    return (width / height) * mHeight;
  }

  return  0;
}


function breadcrumbAr(code = '',w = "news",type = "public"){
  let menu = [];
  if(type == "public") {
    menu = [
      {"title":"医院概况","code":"about_index","child":
          [{"title":"医院简介","code":"profile"},
            {"title":"医院文化","code":"culture"},
            {"title":"交通位置","code":"jtwz"}]
      },
      {"title":"新闻公告","code":"news","child":
          [{"title":"新闻动态","code":"about_news"},
            {"title":"公告公示","code":"tender"},
            {"title":"红十字宣传","code":"red"},
          ]},
      {"title":"人才招聘","code":"talent","child":
          [{"title":"招聘公告","code":"recruitmentmessage"},
            {"title":"人才招聘","code":"talentrecruitment"},
            {"title":"下载专区","code":"down"}

          ]},
      {"title":"党群园地","code":"partygarden",
        "child":[
			{title : "党建工作","code" : "activity"},
			{title : "支部风采","code" : "partybuilding"},
			//{"title":"党建风采","code":"partygarden", },
        
           // {title : "学习园地","code" : "culturaconstruction"},
          
       
          {"title":"群团风采","code":"groupstyle"}]},
      {"title":"护理服务","code":"nursing",
        "child":[{"title":"护理教研","code":"teaching"},
          {"title":"护理科普","code":"specialist"},
          {"title":"专科护理","code":"expert"},
          {"title":"护理前沿","code":"frontier"},
          {"title":"天使心语","code":"angeltalk"}]},
      {"title":"科研教育","code":"scientific",
        "child":[{"title":"科教通知","code":"scientificnotice"},
          {"title":"科研政策","code":"scientificpolicy"},
          {"title":"伦理委员会","code":"ethicscommittee"},
          {"title":"教育进修","code":"educationaladvanceme"},
          {"title":"继续教育","code":"continuingeducation"}]},
	  {"title":"医务社工","code":"worker",'par_url' : '/index/content/volunteer',
	    "child":[
			{"title":"“小淞果”志愿者","code":"volunteer"},
	      {"title":"满意度调查","code":"satisfaction"},
	      {"title":"意见及建议","code":"opinions"}]},
		  
      {"title":"医疗服务","code":"seriver",'par_url' : '/index/news2/servicenotice',
        "child":[{"title":"服务公告","code":"servicenotice"},
          {"title":"门诊安排","code":"arrangement"},
         // {title:"预约挂号","code" : "sub_register"},
         // {title:"楼层分布","code" : "floor_tier"},
       //   {title:"名医工作室","code" : "doctors_job"},
          {"title":"专家介绍","code":"expertabout"},
          {"title":"科室导航","code":"navigation"},
          {"title":"诊疗特色","code":"diagnosis"},
          {"title":"健康科普","code":"health"},
          {"title":"体检中心","code":"physical"},
          {"title":"互联网医院","code":"internet"}]}];
  }

  if(type == "patient") {
    menu = [
      {"title":"医疗服务","code":"seriver",'par_url' : '/index/news2/servicenotice',
        "child":[
          //{title:"预约挂号","code" : "sub_register"},
          {"title":"门诊安排","code":"arrangement"},
          {"title":"专家介绍","code":"expertabout"},
          {"title":"科室导航","code":"navigation"},
          {"title":"诊疗特色","code":"diagnosis"},
          {"title":"服务公告","code":"servicenotice"},
        ]},
      {"title":"互联网医院","code":"internet",'par_url' : '/index/content/internet',
        "child":[
          {"title":"互联网医院","code":"internet"}
          ]},

      {name:"体检中心",code:"physical","url" : "/index/content/physical",child:[
          {"title":"体检中心","code":"physical"},
        ],"left":"-30px"},

      {name:"健康科普",code:"health","url" : "/index/news2/health",child:[
          {"title":"健康科普","code":"health"},
        ],"left":"-30px"},

    ];
  }

  if(code == '') {
    return menu;
  }
  let result = [];
  for(let i in menu) {
    if(menu[i].code == code) {
        result = [{title : menu[i].title,code : menu[i].code,
          url : menu[i].par_url == null ? ( '/index/' + menu[i].code) : menu[i].par_url
        }];
    } else  {
      for(let j in menu[i].child) {
        let d = menu[i].child[j];
        if(d.child != null && d.child.length > 0) {
          for (let k in d.child) {
            let dk = d.child[k];
            if(dk.code == code) {
              result.push({title : menu[i].title,code : menu[i].code,
                url : (menu[i].par_url == null ? ( '/index/' + menu[i].code) : menu[i].par_url)
              });
              result.push({title : dk.title,code : dk.code,url: getBreadUrl(dk.code,menu[i],null,type)});
            }
          }
        } else {
          if(d.code == code) {
            result.push({title : menu[i].title,code : menu[i].code,
              url : menu[i].par_url == null ? ( '/index/' + menu[i].code) : menu[i].par_url
            });
            result.push({title : d.title,code : d.code,url: getBreadUrl(d.code,menu[i],null,type)

            });
          }
        }
      }
    }
  }
  return result;
}

/**
 * 获取当前链接指定位置
 * @param code
 */
function getBreadUrl(code,topMenu = null,type = "public") {
    if(topMenu == null) {
      let menu =  breadcrumbAr("","news",type);

      for(let i in menu) {
        if(menu[i].code == code) {
          topMenu = menu[i];
        } else  {
          for(let j in menu[i].child) {
            let d = menu[i].child[j];
            if(d.code == code) {
              topMenu = menu[i];
              break;
            }
          }
        }
      }
    }

    if(topMenu != null) {
      //人才招聘
      if(topMenu.code == 'talent') {
        //人才招聘栏目
        if(code == 'talentrecruitment') {
          return "/index/talent/talentrecruitment";
        } else {
          return "/index/news2/" + code;
        }
      }
      //党建风采
      if(topMenu.code == 'partygarden') {
        return "/index/news2/" + code;
      }
      //护理服务
      if(topMenu.code == 'nursing') {
        if(code == 'specialist') {
          return  '/index/news2/specialist';
        }
        return "/index/news2/" + code;
      }
      //科研管理
      if(topMenu.code == 'scientific') {
        return  '/index/news2/' + code;
      }

      if(topMenu.code == 'seriver') {

        if(code == 'seriver') {
              return  '/index/news2/servicenotice';
          }

          if(code == 'arrangement') {
              return '/index/content/arrangement';
          }

          if(code == 'navigation') {
            return  '/index/service/navigation';
          }

          if(code == 'expertabout') {
            return  '/index/service/expertabout';
          }

          if(code == 'internet') {
            return '/index/content/internet';
          }

        if(code == 'physical') {
          return '/index/content/physical';
        }
		
		

        return  '/index/news2/' + code;
      }
		
		if(code == 'volunteer') {
			 return '/index/content/volunteer';
		}
		if(code == 'satisfaction') {
		  return '/index/content/satisfaction';
		}
		
		if(code == 'opinions') {
		  return '/index/content/opinions';
		}

      return "/index/news/" + code;
    }
}



export default {
    date 		    : date,//日期(类似PHP)
    strtotime   : strtotime,//时间(类似PHP)
    returnFloat : returnFloat,//小数位数
    isDefine    : isDefine,//判断是否存在
    timest      : timest,//时间戳
    loading     : loading,//加载层类
    loadingClose: loadingClose,//关闭加载层
    util        : util,
  resetFields   : resetFields,
    urlParam    : urlParam,
  imgAr         : imgAr,
  isPoneAvailable : isPoneAvailable,
  CountDowm     : CountDowm,
  getDateTime:getDateTime,
  checkPermissions : checkPermissions,
  RichText : RichText,
  getAotuWidth  :getAotuWidth,
  breadcrumbAr : breadcrumbAr,
  getBreadUrl  : getBreadUrl
}



// WEBPACK FOOTER //
// ./src/utils/comm.js